// ==================================================================================
// UNIFIED BREEZE TRACKING (GA4 + GOOGLE ADS)
// ==================================================================================

(function initializeTracking() {
  const GOOGLE_ADS_ID = 'AW-624342049';
  const GA4_MEASUREMENT_ID = 'G-264LF5RDJS';

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' +
      encodeURIComponent(GOOGLE_ADS_ID);
    document.head.appendChild(script);
  }

  if (!window.__breezeGoogleTagInitialized) {
    window.gtag('js', new Date());
    window.__breezeGoogleTagInitialized = true;
  }

  window.gtag('config', GOOGLE_ADS_ID);
  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: false
  });
})();

const BREEZE_CONFIG = {
  gadsId: 'AW-624342049',
  ga4Id: 'G-264LF5RDJS',
  purchaseDestination: 'AW-624342049/cN7XCLjwu6gcEKHo2qkC',
  beginCheckoutDestination: 'AW-624342049/TdLkCJympaQcEKHo2qkC',
  addPaymentInfoDestination: null // Add Google Ads label here when available
};

// ==================================================================================
// CHECKOUT INIT (BEGIN CHECKOUT)
// ==================================================================================

['checkout-init', 'breeze-checkout-init', 'breeze-initiate-checkout'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Checkout Init');
    if (!params) return;

    try {
      const items = createItems(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createUserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toNumber(params.totalPrice);
      const eventTime = new Date().toISOString();

      // Single DataLayer Push
      window.dataLayer.push({
        event: 'checkout-init',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: {
          currency: currency,
          value: value,
          coupon: params.coupon || '',
          items: items
        },
        breeze_event_type: 'checkout-init',
        breeze_event_time: eventTime
      });

      // GA4 Event
      window.gtag('event', 'begin_checkout', {
        send_to: BREEZE_CONFIG.ga4Id,
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        items: items,
        user_data: userData,
        breeze_event_type: 'checkout-init',
        breeze_event_time: eventTime
      });

      // Google Ads Event
      window.gtag('event', 'begin_checkout', {
        send_to: [BREEZE_CONFIG.beginCheckoutDestination],
        developer_id: { dNzYwYj: true },
        ecomm_prodid: items.map(function (item) { return item.item_id; }),
        ecomm_totalvalue: value,
        ecomm_pagetype: 'cart',
        value: value,
        currency: currency,
        items: items,
        user_data: userData,
        google_analysis_params: {
          lineItemValue: calculateItemsValue(items),
          totalPriceValue: value
        },
        breeze_event_type: 'checkout-init',
        breeze_event_time: eventTime
      });
    } catch (error) {
      logTrackingError('checkout-init', error);
    }
  });
});

// ==================================================================================
// ADD SHIPPING INFO (GA4)
// ==================================================================================

['add-shipping-info', 'breeze-add-shipping-info'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Add shipping info');
    if (!params) return;

    try {
      const items = createItems(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createUserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toNumber(params.totalPrice);
      const eventTime = new Date().toISOString();

      window.dataLayer.push({
        event: 'add_shipping_info',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: {
          currency: currency,
          value: value,
          coupon: params.coupon || '',
          shipping_tier: params.shippingTier || '',
          items: items
        },
        breeze_event_type: 'add_shipping_info',
        breeze_event_time: eventTime
      });

      window.gtag('event', 'add_shipping_info', {
        send_to: BREEZE_CONFIG.ga4Id,
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        shipping_tier: params.shippingTier || '',
        items: items,
        user_data: userData,
        breeze_event_type: 'add_shipping_info',
        breeze_event_time: eventTime
      });
    } catch (error) {
      logTrackingError('add_shipping_info', error);
    }
  });
});

// ==================================================================================
// PAYMENT SCREEN (ADD PAYMENT INFO)
// ==================================================================================

['payment-screen', 'breeze-payment-screen', 'breeze-add-payment-info'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Payment Screen');
    if (!params) return;

    try {
      const items = createItems(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createUserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toNumber(params.totalPrice);
      const eventTime = new Date().toISOString();

      window.dataLayer.push({
        event: 'payment-screen',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: {
          currency: currency,
          value: value,
          coupon: params.coupon || '',
          payment_type: params.paymentMethodType || '',
          items: items
        },
        breeze_event_type: 'payment-screen',
        breeze_event_time: eventTime
      });

      // GA4 Event
      window.gtag('event', 'add_payment_info', {
        send_to: BREEZE_CONFIG.ga4Id,
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        payment_type: params.paymentMethodType || '',
        items: items,
        user_data: userData,
        breeze_event_type: 'payment-screen',
        breeze_event_time: eventTime
      });

      // Google Ads Event
      if (BREEZE_CONFIG.addPaymentInfoDestination) {
        window.gtag('event', 'add_payment_info', {
          send_to: [BREEZE_CONFIG.addPaymentInfoDestination],
          developer_id: { dNzYwYj: true },
          currency: currency,
          value: value,
          items: items,
          user_data: userData,
          payment_type: params.paymentMethodType || '',
          breeze_event_type: 'payment-screen',
          breeze_event_time: eventTime
        });
      }
    } catch (error) {
      logTrackingError('payment-screen', error);
    }
  });
});

// ==================================================================================
// ORDER PLACED (PURCHASE)
// ==================================================================================

['order-placed', 'breeze-order-placed', 'breeze-purchase'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Order Placed');
    if (!params) return;

    try {
      const items = createItems(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createUserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toNumber(params.totalPrice);
      const tax = toNumber(params.tax);
      const shipping = toNumber(
        params.shippingCharge !== undefined
          ? params.shippingCharge
          : params.shipping
      );
      const eventTime = new Date().toISOString();

      // Single DataLayer Push
      window.dataLayer.push({
        event: 'order-placed',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: {
          transaction_id: String(params.shopOrderId || ''),
          currency: currency,
          value: value,
          tax: tax,
          shipping: shipping,
          coupon: params.coupon || '',
          items: items
        },
        breeze_event_type: 'order-placed',
        breeze_event_time: eventTime
      });

      // GA4 Event
      window.gtag('event', 'purchase', {
        send_to: BREEZE_CONFIG.ga4Id,
        transaction_id: String(params.shopOrderId || ''),
        currency: currency,
        value: value,
        tax: tax,
        shipping: shipping,
        coupon: params.coupon || '',
        items: items,
        user_data: userData,
        customer_type: params.customerType || '',
        payment_type: params.paymentMethodType || '',
        breeze_event_type: 'order-placed',
        breeze_event_time: eventTime
      });

      // Google Ads Event
      window.gtag('event', 'purchase', {
        send_to: [BREEZE_CONFIG.purchaseDestination],
        developer_id: { dNzYwYj: true },
        transaction_id: String(params.shopOrderId || ''),
        value: value,
        currency: currency,
        tax: tax,
        shipping: shipping,
        items: items,
        user_data: userData,
        customer_type: params.customerType || '',
        payment_type: params.paymentMethodType || '',
        google_analysis_params: {
          lineItemValue: calculateItemsValue(items),
          totalPriceValue: value
        },
        breeze_event_type: 'order-placed',
        breeze_event_time: eventTime
      });
    } catch (error) {
      logTrackingError('order-placed', error);
    }
  });
});

// ==================================================================================
// SHARED UTILITIES
// ==================================================================================

function getBreezeEventData(event, eventName) {
  if (!event || !event.detail || !event.detail.data) {
    console.error(eventName + ': invalid event data. Expected event.detail.data.');
    return null;
  }
  return event.detail.data;
}

function createItems(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.map(function (item, index) {
    return {
      item_id: 'shopify_IN_' + String(item.id || '') + '_' + String(item.variant || ''),
      id: 'shopify_IN_' + String(item.id || '') + '_' + String(item.variant || ''),
      item_name: item.name || '',
      name: item.name || '',
      item_brand: item.vendor || '',
      brand: item.vendor || '',
      item_category: item.productType || '',
      category: item.productType || '',
      item_variant: item.variantTitle || String(item.variant || ''),
      variant: item.variantTitle || String(item.variant || ''),
      coupon: item.discount || '',
      price: toNumber(item.price),
      quantity: toNumber(item.quantity),
      currency: item.currency || 'INR',
      index: index
    };
  });
}

function createUserData(userData) {
  if (!userData || typeof userData !== 'object') {
    return undefined;
  }

  return {
    email: userData.email || '',
    phone_number: userData.phone || userData.phoneNumber || '',
    address: {
      first_name: userData.firstName || userData.name || '',
      last_name: userData.lastName || '',
      street: userData.address || userData.street || '',
      city: userData.city || '',
      region: userData.state || userData.region || '',
      postal_code: userData.postalCode || userData.zip || userData.zipCode || '',
      country: userData.country || 'IN'
    }
  };
}

function calculateItemsValue(items) {
  return items.reduce(function (total, item) {
    return total + toNumber(item.price) * toNumber(item.quantity);
  }, 0);
}

function toNumber(value) {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function logTrackingError(source, error) {
  console.error('Breeze tracking (' + source + ') failed:', error);
  if (error && error.stack) {
    console.error(error.stack);
  }
}